<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_Logo">
        <span
          class="col-form-label"
        >Verify the logo and markings match the manufacturers specification</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_Markings"
      >
        <span
          class="col-form-label"
        >Confirm the markings are clear and do not appear to be re-marked or re-stamped</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_MarkingTopBottom"
      >
        <span
          class="col-form-label"
        >Confirm the markings are consistentthroughout the package type from part to part and on top and bottom of parts</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_LaserMarks"
      >
        <span
          class="col-form-label"
        >Inspect laser marks for burn holes caused by aftermarkerket laser equipment</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_Size">
        <span
          class="col-form-label"
        >Inspect for inconsistencies in package indents shape, size and locations</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_Burns">
        <span
          class="col-form-label"
        >Confirm that thereare no burn or blister marks, or evidence of exposure to excessive heat.</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_Dots">
        <span
          class="col-form-label"
        >Ensure that there are no colored dots or ink marks on the tops of components indicating previous testing</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_FLux">
        <span
          class="col-form-label"
        >Look for flux or chemical residue and toolmarks indicating the part may be refurbished</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_Cracks"
      >
        <span class="col-form-label">Confirm there are no cracks on the surface of the parts</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_PinCount"
      >
        <span
          class="col-form-label"
        >Verify the lead/pin count and formation of type of lead (DIP, SM8, Gull, Wing, etc) match the datasheet</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_Terminal"
      >
        <span class="col-form-label">Verify pins or terminal layout/count match manufacturer specs</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_Leads">
        <span
          class="col-form-label"
        >Inspect for damaged leads (Sent, Scratched, broken, dented, missing etc.) indicating the part has been salvaged</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_Oxidation"
      >
        <span
          class="col-form-label"
        >Ensure the leads are not oxidized or show contamination from foreign substances</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_SuspectPart"
      >
        <span
          class="col-form-label"
        >Look for leads that are too shiny for older date codes or too dull for newer date codes</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.detailInspection_Scratches"
      >
        <span
          class="col-form-label"
        >Confirm there are no scratches on the inside and outside of leads or any signs of reballing</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_BGA">
        <span
          class="col-form-label"
        >Inspect 8GAs, LGAs, and any terminals, lugs, or connectors to insure component has not been used</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Pass', 'Fail', 'N/A']" v-model="model.detailInspection_Photo">
        <span class="col-form-label">Photograph markings front and back for records</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaVisualDetailed',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        detailInspection_Logo: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__LOGO] || '',
        detailInspection_Markings: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__MARKINGS] || '',
        detailInspection_MarkingTopBottom: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__MARKING_TOP_BOTTOM] || '',
        detailInspection_LaserMarks: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__LASER_MARKS] || '',
        detailInspection_Size: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__SIZE] || '',
        detailInspection_Burns: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__BURNS] || '',
        detailInspection_Dots: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__DOTS] || '',
        detailInspection_FLux: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__FLUX] || '',
        detailInspection_Cracks: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__CRACKS] || '',
        detailInspection_PinCount: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__PIN_COUNT] || '',
        detailInspection_Terminal: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__TERMINAL] || '',
        detailInspection_Leads: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__LEADS] || '',
        detailInspection_Oxidation: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__OXIDATION] || '',
        detailInspection_SuspectPart: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__SUSPECT_PART] || '',
        detailInspection_Scratches: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__SCRATCHES] || '',
        detailInspection_BGA: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__BGA] || '',
        detailInspection_Photo: this.inspectionDetails[FIELDS.DETAIL_INSPECTION__PHOTO] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>